/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods200,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods500,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryResponse,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsPathParams>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods500>;

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethods200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidAvailablePaymentMethodsQueryResponse>;
